import { render } from "./ErpForm.vue?vue&type=template&id=76d7be9c&scoped=true"
import script from "./ErpForm.vue?vue&type=script&lang=js"
export * from "./ErpForm.vue?vue&type=script&lang=js"

import "./ErpForm.vue?vue&type=style&index=0&id=76d7be9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d7be9c"]])

export default __exports__